import React from 'react';
import { cn } from '@/utils';

const colors = {
  wp: '#12789d',
  woo: '#8359b5',
  acf: '#44efbb',
  gf: '#f25f32',
};

export default function ModeLogo({
  slug,
  className,
}: {
  slug: string;
  className?: string;
}) {
  const logos = import.meta.glob('../../../images/modes/*.svg', {
    eager: true,
    as: 'raw',
  });
  const logo = logos[`../../../images/modes/${slug}.svg`] ?? null;

  return (
    <span
      dangerouslySetInnerHTML={{ __html: logo }}
      className={cn(
        'inline-block [&_svg]:h-full [&_svg]:w-full [&_svg]:fill-current',
        className,
      )}
      // style={{ color: colors[slug] ?? null }}
    ></span>
  );
}
